<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<img alt="Cover Image" height="100%" src="images/9780316133890.jpg" title="Cover"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?26df5101